export enum Launch_Relax_No_Limit_City {
  "ES" = "ES",
  "HU" = "HU",
}
